/**
 * Not found — any address the router does not know (ADR-0007). Served by
 * the error page of the application with a 404 status, written by the
 * server (templates/site/notfound.html.twig).
 *
 * @module pages/notfound
 */

import { $ } from '../lib/dom.js';
import * as opening from '../sections/notfound/opening.js';

export function animate() {
    opening.animate($('#lost'));
}
